import axios from 'axios';
import {
  rootUrl,
  basketFloatDelay,
  basketFloatWidth,
  basketFloatzIndex
} from './config';
import {loadLoginPopup} from './customer';
import globalEvent from "./eventEmitter";
import {add2basketfromco} from './checkout';

function bindBasketEvents(){
  // hide popup-basket on default
  var ele=$("div.popup-basket");
  if(ele && ele.length) ele[0].style.display="none";

  // popup-basket event
  $(".popup-basket").on("click", function(evt){
    evt.stopPropagation();
  });

  $(".popup-basket button.btn-clear").on("click", function(evt){
    evt.stopPropagation();
    clearBasket(this);
  });
  $(".popup-basket button[name='remove_basket_row']").on("click", function(evt){
    evt.stopPropagation();
    removeBasket($(this).data("pid"),this);
  });
  $(".popup-basket button[name='decrease_qty'],button[name='increase_qty']").on("click", function(evt){
    evt.stopPropagation();
    changeQty($(this).data("pid"),$(this).val(),this);
  });
  $(".popup-basket input[name='qty']").on("change", function(evt){
    evt.stopPropagation();
    changeQty($(this).data("pid"),$(this).val(),this);
  });
  $(".popup-basket input[name='qty']").on("click", function(evt){
    evt.stopPropagation();
  });
  $("div.popup-basket button.basket-close-btn").bind("click", basketToogleHandler);
  $('.wex-mobile-basket img.shopping-basket, div.basket-item-count').off("click").on("click", basketToogleHandler);

  // touch outside to disable popup
  $('#header,#wex_wrap').on("click", function(evt){
    // disable basket popup
    let ele=$("div.popup-basket");
    if(ele && ele.length){
      ele[0].style.display="none";
    }

    // disable favorite popup
    ele=$("div.popup-favorite");
    if(ele && ele.length){
      ele[0].style.display="none";
    }

    // disable select-country popup
    ele=$("div.popup-select-country");
    if(ele && ele.length){
      ele[0].style.display="none";
    }
    
  });

}


function gotoFavListHandler(evt){
  evt.stopPropagation();
  var ele=$("div.prod-fv-list");
  if(ele && ele.length){
    ele[0].scrollIntoView(false);
  }
}

function favoriteToggleHandler(evt) {
  evt.stopPropagation();
  // turn off basket popup first
  const basketPopup = $("div.popup-basket");
  if (basketPopup && basketPopup.length) {
    if(basketPopup[0].style.display == "block"){
      basketPopup[0].style.display="none";
    }
  }

  const selectCountryPopup = $("div.popup-select-country");
  if (selectCountryPopup && selectCountryPopup.length) {
    if(selectCountryPopup[0].style.display == "block"){
      selectCountryPopup[0].style.display="none";
    }
  }

  // toggle favorite popup
  const ele = $("div.popup-favorite");
  if (ele && ele.length) {
    if(ele[0].style.display == "none"){
      ele[0].style.display="block";
    } else {
      ele[0].style.display="none";
    }
  }
}

function selectCountryToggleHandler(evt) {
  evt.stopPropagation();
  // turn off basket popup first
  const basketPopup = $("div.popup-basket");
  if (basketPopup && basketPopup.length) {
    if(basketPopup[0].style.display == "block"){
      basketPopup[0].style.display="none";
    }
  }

  const  favoritePopup = $("div.popup-favorite");
  if (favoritePopup && favoritePopup.length) {
    if(favoritePopup[0].style.display == "block"){
      favoritePopup[0].style.display="none";
    }
  }

  // toggle select country popup
  const ele = $("div.popup-select-country");
  if (ele && ele.length) {
    if(ele[0].style.display == "none"){
      ele[0].style.display="block";
    } else {
      ele[0].style.display="none";
    }
  }
}

function basketToogleHandler(evt){
  evt.stopPropagation();
  // turn off favorite popup first
  const favoritePopup = $("div.popup-favorite");
  if (favoritePopup && favoritePopup.length) {
    if(favoritePopup[0].style.display == "block"){
      favoritePopup[0].style.display="none";
    }
  }

  // turn off select-country popup second
  const selectCountryPopup = $("div.popup-select-country");
  if (selectCountryPopup && selectCountryPopup.length) {
    if(selectCountryPopup[0].style.display == "block"){
      selectCountryPopup[0].style.display="none";
    }
  }

  // toggle basket popup
  const ele=$("div.popup-basket");
  if(ele && ele.length){
    if(ele[0].style.display == "none"){
      let mobileMenu = $("div.mobile-menu-wrapper");
      if(mobileMenu && mobileMenu.length) mobileMenu[0].style.display="none";
      ele[0].style.display="block";
    } else {
      ele[0].style.display="none";
      $.LoadingOverlay("hide",true);
    }
  }
}

function bindBasketToUI(data) {
  const scrollPos = $("div.basket-body").scrollTop();
  let basketCnt=$("div.popup-basket");
  let cssText=null;
  if(basketCnt && basketCnt.length) cssText=basketCnt[0].style.cssText;

  // remove basket popup first
  $("div.popup-basket").remove();
  if(data && data.html){
    // insert basket popup HTML
    $(data.html).insertAfter($("div.wex-mobile-basket"));
  }

  if (data) {
    if (data.favorite_html !== undefined) {
      insertWishListPopupHTML(data.favorite_html);
      bindWishListPopupEvents();
    }
  }

  if(data && data.data){
    data.data.basket_count=isNaN(data.data.basket_count)?0:Number(data.data.basket_count);
    $("div.basket-item-count").html(data.data.basket_count);
  }

  if(data && data.wishlist){
    data.wishlist.fav_count=isNaN(data.wishlist.length)?0:Number(data.wishlist.length);
    $("div.fav-item-count").html(data.wishlist.fav_count);
    if(Number(data.wishlist.fav_count) > 0) $("img.fav-products").attr("src","/images/system/heart_fill.jpg");
    else $("img.fav-products").attr("src","/images/system/heart_outline.jpg");
  }

  bindBasketEvents();
  basketCnt=$("div.popup-basket");
  if(basketCnt && basketCnt.length && cssText) basketCnt[0].style.cssText=cssText;
  $("div.basket-body").scrollTop(scrollPos);
}

function insertWishListPopupHTML(favorite_html) {
  // get current status
  var favPopup=$("div.popup-favorite");
  var cssText=null;
  if(favPopup && favPopup.length) cssText=favPopup[0].style.cssText;

  // remove old wishlist popup html
  var oldFavorite = $("div.popup-favorite");
  if (oldFavorite && oldFavorite.length > 0) {
    oldFavorite.remove();
  }

  // Insert wishlist html
  if(favorite_html) {
    // Only insert if server response new html
    // remove the old one first
    $("div.popup-favorite").remove();

    // insert
    $(favorite_html).insertAfter($("div.wex-mobile-basket"));

    var favoritePopup = $("div.popup-favorite");
    if (favoritePopup && favoritePopup.length) {
      if (cssText) {
        // keep current state
        favoritePopup[0].style=cssText;
      } else {
        // hide popup-favorite on default
        favoritePopup[0].style.display="none";
      }
    }

    // if basket icon is hidden => shift favorite icon to the right
    if ($(".shopping-basket:hidden").length > 0) {
      $(".popup-favorite .arrow-up").css({"right": "11px"});
    }
  }
}

function isCheckoutPage() {
  if($("#checkout_page").length > 0) return true;
  return false;
}

function bindWishListPopupEvents() {
  // popup favorite event
  $(".popup-favorite").off("click").on("click", function(evt){
    evt.stopPropagation();
  });

  // Click favorite icon to pen wishlist popup
  $(".wex-mobile-basket img.fav-products, div.fav-item-count").off("click").on("click", favoriteToggleHandler);

  // Click close button on popup to close wishlist popup
  $("div.popup-favorite button.basket-close-btn").off("click").on("click", favoriteToggleHandler);

  // Click button to remove favorite
  $("button.popup-favorite-remove").off("click").on("click", function() {
    removefromfv(this,$(this).data("pid"));
  })

  // Click add button to add to cart
  $("button.popup-favorite-add-to-cart").off("click").on("click", function() {
    // check if we are on checkout page or not
    if (isCheckoutPage()) {
      // use this function to also update basket rows
      add2basketfromco(this, $(this).data("pid"), 'search');
    } else {
      // otherwise, use this function
      add2basket(this, $(this).data("pid"), 'search');
    }
  })
}

function bindFavoriteUI(data) {
  if(data && data.wishlist){
    data.wishlist.fav_count=isNaN(data.wishlist.length)?0:Number(data.wishlist.length);
    $("div.fav-item-count").html(data.wishlist.fav_count);
    if(Number(data.wishlist.fav_count) > 0) $("img.fav-products").attr("src","/images/system/heart_fill.jpg");
    else $("img.fav-products").attr("src","/images/system/heart_outline.jpg");
  }
}

function clearBasket(ele) {
  let url=`${rootUrl}/basket/clear`;
  axios({url:url,method:'POST'}).then(function(res) {
    bindBasketToUI(res.data);
  }).catch(function(err){
    console.log(err);
  });
}

function removeBasket(pId, ele) {
  let url=`${rootUrl}/basket/remove`;
  axios({url:url,method:'POST',data:{product_id:pId}}).then(function(res) {
    bindBasketToUI(res.data);
  }).catch(function(err){
    console.log(err);
  });
}

function changeQty(pId, qty, ele) {
  let url=`${rootUrl}/basket/qty`;
  qty = isNaN(qty)?0:Number(qty);
  if(qty <= 0) qty=1;
  axios({url:url,method:'POST',data:{product_id:pId, qty: qty}}).then(function(res) {
    bindBasketToUI(res.data);
  }).catch(function(err){
    console.log(err);
  });
}

function getBasket(){
  let url=`${rootUrl}/basket/load`;
  axios({url:url,method:'GET'}).then(function(res) {
    bindBasketToUI(res.data);
  }).catch(function(err){
    console.log(err);
  });
}

function reloadFavoritePopupHTML() {
  let url=`${rootUrl}/basket/load`;
  axios({url:url,method:'GET'}).then(function(res) {
    bindBasketToUI(res.data);
  }).catch(function(err){
    console.log(err);
  });
}

function add2basket(ele, pId, from, price){
  let url=`${rootUrl}/add2basket`;
  $(ele).addClass("adding-to-basket");
  axios({url:url,method:'POST',data:{product_id:pId,from:from}}).then(function(res) {
    $(ele).removeClass("adding-to-basket");
    bindBasketToUI(res.data);
    if(res.data && res.data.data)  basketChanged(pId,res.data.data.add2cart_txt);
  }).catch(function(err){
    $(ele).removeClass("adding-to-basket");
    console.log(err);
  });
  let n= $(ele).parents(".product-wrapper").find(".product-name").text().trim();
  if (from=='product_detail') n = $(".product-detail .right .product-name").text().trim();
  if (window.dataLayer) window.dataLayer.push({'product_id': pId,'product_name': n,'product_price': price,'currency': 'SEK','content_category': from,'event': 'wh_add_basket'});
}

function fvBindingEvents() {
  $("div.product-detail div.addcart img.fv-add").on("click",function(evt){
    evt.stopPropagation();
    add2fv(this,$(this).data("pid"));
  });
  $("div.product-detail div.addcart img.fv-remove").on("click",function(evt){
    evt.stopPropagation();
    removefromfv(this,$(this).data("pid"));
  });
  $("div.product-cell.fv-item button.close-btn").on("click",function(evt){
    evt.stopPropagation();
    removefromfv(this,$(this).data("pid"));
  });
  $(".favorite-button-unselected").on("click", function(evt){
    evt.stopPropagation();
    add2fv(this,$(this).data("pid"));
  })
  $(".favorite-button-selected").on("click", function(evt){
    evt.stopPropagation();
    removefromfv(this,$(this).data("pid"));
  })
  $("button.popup-favorite-remove").click(function() {
    removefromfv(this, $(this).data("pid"));
  })
}

function add2fv(ele, pId){
  let isLoggedIn = $("button[name='cust_info']").val() != "";
  if (!isLoggedIn) return loadLoginPopup(ele);
  let url=`${rootUrl}/product/wishlist`;
  axios({url:url,method:'POST',data:{pId:pId}}).then(function(res) {
    if(res.data && res.data.status && res.data.html){
      $(`.prod-fv-list`).closest(".product-list-container").remove();
      $(res.data.html).insertBefore($(".wex-container .tp-slider.wh-widget"));

      if ($(ele).hasClass("favorite-button")) {
        $(ele).removeClass("favorite-button-unselected").addClass("favorite-button-selected");

        $(".favorite-button-selected").off("click")
        $(".favorite-button-selected").on("click", function(evt){
          evt.stopPropagation();
          removefromfv(this,$(this).data("pid"));
        })

      } else {
        $(ele).removeClass("fv-add").addClass("fv-remove");
        $(ele).attr("src",$(ele).data("img-fill"));
      }

      $("div.product-detail div.addcart img.fv-remove").off("click");
      $("div.product-detail div.addcart img.fv-remove,div.product-cell.fv-item button.close-btn").on("click",function(evt){
        evt.stopPropagation();
        removefromfv(this,$(this).data("pid"));
      });

      // alert event wish list changed number of items
      globalEvent.emit("wishlist-num-changed")
    }
  }).catch(function(err){
    console.log(err);
  });
}

function removefromfv(ele, pId){
  let url=`${rootUrl}/product/wishlist`;
  axios({url:url,method:'DELETE',data:{pId:pId}}).then(function(res) {
    if(res.data && res.data.status){
      $(`.prod-fv-list .product-cell.fv-item.prodid-${pId}`).remove();

      if ($(ele).hasClass("favorite-button")) {
        // handle when user click on favorite button on product cell

        // toggle favorite icon on this product cell
        $(ele).removeClass("favorite-button-selected").addClass("favorite-button-unselected");

        // rebinding click event on favorite product cells
        $(".favorite-button-unselected").off("click")
        $(".favorite-button-unselected").on("click", function(evt){
          evt.stopPropagation();
          add2fv(this,$(this).data("pid"));
        })

      } else if($(ele).hasClass("fv-remove")){
        // favorite button on product detail

        // toggle favorite icon on product detail
        $(ele).removeClass("fv-remove").addClass("fv-add");
        $(ele).attr("src",$(ele).data("img-nofill"));
      } else if ($(ele).hasClass("close-btn")) {
        // handle when user click remove button from favorited product list

        // toggle favorite icon on favorite product cells
        $(`.favorite-button-selected[data-pid='${pId}']`).removeClass("favorite-button-selected").addClass("favorite-button-unselected");

        // rebinding click event on favorite product cells
        $(".favorite-button-unselected").off("click")
        $(".favorite-button-unselected").on("click", function(evt){
          evt.stopPropagation();
          add2fv(this,$(this).data("pid"));
        })
      } else if($(ele).hasClass("popup-favorite-remove")) {
        // toggle favorite icon on favorite product cells
        $(`.favorite-button-selected[data-pid='${pId}']`).removeClass("favorite-button-selected").addClass("favorite-button-unselected");

        // rebinding click event on favorite product cells
        $(".favorite-button-unselected").off("click")
        $(".favorite-button-unselected").on("click", function(evt){
          evt.stopPropagation();
          add2fv(this,$(this).data("pid"));
        })
      }

      // rebinding click event on product detail page
      $("div.product-detail div.addcart img.fv-add").off("click");
      $("div.product-detail div.addcart img.fv-add").on("click",function(evt){
        evt.stopPropagation();
        add2fv(this,$(this).data("pid"));
      });

      // remove favorite list if there is no item inside
      if($(`.prod-fv-list .product-cell.fv-item`).length <= 0) {
        $(`.prod-fv-list`).closest(".product-list-container").remove();
      }

      // alert event wish list changed number of items
      globalEvent.emit("wishlist-num-changed")
    }
  }).catch(function(err){
    console.log(err);
  });
}

function basketChanged(product_id, txt){
  var m_left=Number($(".wex-mobile-basket").offset().left+$(".wex-mobile-basket").width()-basketFloatWidth);
  var m_top = Number($("#header").height())+Number($("#txtbar").height());
  $(".notifications.top-right").css({"top": m_top+"px","z-index":`${basketFloatzIndex}`,"left":m_left+"px"});
  var selector = ".product.id-"+product_id;
  var added_row = $(selector)[0];
  added_row = $(added_row).clone();
  $(added_row).find('.price').remove();
  $(added_row).find('.action').remove();
  var pname = $(added_row).find(".b-info .name a").html();
  $(added_row).find(".b-info .name a").remove();
  $(added_row).find(".b-info .name").html(pname);
  $(added_row).find(".b-info").append("<div class='msg'>"+txt+"</div>");
  $('.top-right').notify({
    message: { html: $(added_row).html() },
    closable: false,
    fadeOut: { delay: basketFloatDelay},
    type:"wexthuset",
    onClose: function() {
      if($(".notifications.top-right").children().length <= 0)
        $(".notifications.top-right").css({"top": "72px","z-index":"1"});
    }
  }).show();
}

export {add2basket, getBasket,fvBindingEvents, removefromfv, reloadFavoritePopupHTML,selectCountryToggleHandler};
